module.exports = __webpack_public_path__ + "static/media/btch.7073b5e7.svg";